"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCategoryReducer = exports.createCategoryReducer = exports.fetchCategoryReducer = exports.updateCategorySlice = exports.createCategorySlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const categoryAction_1 = require("./categoryAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: [],
};
const createInitialState = {
    loading: false,
    error: null,
    data: [],
};
const updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
const fetchSlice = (0, toolkit_1.createSlice)({
    name: "categories/fetch",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(categoryAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(categoryAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(categoryAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.createCategorySlice = (0, toolkit_1.createSlice)({
    name: "categories/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(categoryAction_1.create.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(categoryAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(categoryAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.updateCategorySlice = (0, toolkit_1.createSlice)({
    name: "categories/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(categoryAction_1.update.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(categoryAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(categoryAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.fetchCategoryReducer = fetchSlice.reducer;
exports.createCategoryReducer = exports.createCategorySlice.reducer;
exports.updateCategoryReducer = exports.updateCategorySlice.reducer;
